import { render } from "./Swipe.vue?vue&type=template&id=88c54f1e&scoped=true"
import script from "./Swipe.vue?vue&type=script&lang=js"
export * from "./Swipe.vue?vue&type=script&lang=js"

import "./Swipe.vue?vue&type=style&index=0&id=88c54f1e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c54f1e"]])

export default __exports__